module.exports = __webpack_public_path__ + "static/media/robolinks.5a8b9ba5.jpg";